const BenefitsColor = function() {
    function BenefitsColor() {
        this.selector = {
            video: document.querySelectorAll(".benefit-video-tag")
        }
        this.load();
    }
    BenefitsColor.prototype.load = function() {
        var _ = this;
        let loaded = false;
        window.addEventListener("scroll", function() {
                if(_.selector.video.length > 0 && !loaded && window.scrollY > 10) {
                    _.selector.video.forEach(el => {
                        el.src = el.dataset.videoSrc;
                    })
                    loaded = true;
                }
        })
    }
    BenefitsColor = new BenefitsColor;
}
BenefitsColor();